/**
 * Application-wide constants
 */

export const LANGUAGES = {
  ARABIC: 'ar',
  ENGLISH: 'en'
};

export const DIRECTIONS = {
  RTL: 'rtl',
  LTR: 'ltr'
};

export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1200,
  WIDE: 1440
};

export const STORAGE_KEYS = {
  LANGUAGE: 'preferred_language',
  THEME: 'preferred_theme',
  USER_PREFERENCES: 'user_preferences'
};

export const ROUTES = {
  HOME: '/',
  PRIVACY_POLICY: '/privacy-policy'
};

export const EXTERNAL_LINKS = {
  PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.cave.litanigateway',
  APP_STORE: '#', // To be updated when available
  MUNICIPALITY_WEBSITE: 'https://www.qaqaaiyataljiser.com/',
  FACEBOOK: '#',
  INSTAGRAM: '#',
  TWITTER: '#'
};

export const APP_INFO = {
  NAME: 'بوابة الليطاني - Litani Gateway',
  VERSION: '1.0.0',
  DESCRIPTION: 'Official municipality app for Qaqaaiyat Al Jiser',
  MUNICIPALITY: 'Qaqaaiyat Al Jiser',
  MUNICIPALITY_AR: 'بلدية قاقعية الجسر'
};

export const CONTACT_INFO = {
  PHONE: '+961-XX-XXXXXX',
  EMAIL: 'info@qaqaaiyataljiser.com',
  ADDRESS: 'Qaqaaiyat Al Jiser, Lebanon',
  ADDRESS_AR: 'قاقعية الجسر، لبنان'
};

export const FEATURE_FLAGS = {
  CONTACT_FORM: true,
  NEWS_SECTION: true,
  NOTIFICATIONS: true,
  ANALYTICS: false,
  ERROR_REPORTING: false
};